import React from 'react';
import { Outlet } from 'react-router-dom';
import AppHeader from './AppHeader';
import BottomNav from './BottomNav';

const Layout: React.FC = () => {
  return (
    <div className="app">
      <AppHeader />

      <main className="main-content">
        <Outlet />
      </main>

      <BottomNav />
    </div>
  );
};

export default Layout;
